import { Typography, Box } from "@material-ui/core";
import { RECENT_DELIVERY } from "../../../Common/constant";
import PieChart from "../../../Common/GoogleCharts/PieChart";
import { useNavigate } from "react-router-dom";

export default function RecentDelivery({ recentData }) {
    const navigate = useNavigate();
    const graphClick = (origin) => {
        localStorage.removeItem('wostatusname');
        localStorage.removeItem('origin');
        localStorage.removeItem('wopendingthismonth');
        localStorage.removeItem('wostatus');
        const wostatus = 30
        localStorage.setItem('wostatus', wostatus);
        localStorage.setItem('origin', origin);
        navigate('/work-order/summary');
    }
    const handleClick = () => {
        localStorage.removeItem('wostatusname');
        localStorage.removeItem('origin');
        localStorage.removeItem('wopendingthismonth');
        localStorage.removeItem('wostatus');
        navigate({ pathname: '/work-order/summary' })
    }
    return (
        <>
            <Box>
                <span style={{ cursor: 'pointer' }} onClick={() => handleClick()}>
                    <Typography align="left" className="reportTitle">{RECENT_DELIVERY}</Typography>
                </span>
                <PieChart data={recentData} graphClick={graphClick} />
            </Box>
        </>
    )
}